import { inject, Pipe, PipeTransform, signal } from "@angular/core";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";

const ASTERISKS = "****";
@Pipe({
  name: "asterisks",
  pure: false,
})
export class AsterisksPipe implements PipeTransform {
  protected userStore = inject(UserStoreService);
  transform(
    value: number | string,
    currencyCode?: string,
    display?: "code" | "symbol" | "symbol-narrow" | string,
    digitsInfo?: string,
    locale?: string,
  ): string {
    return this.userStore.showBalance() ? value.toString() : ASTERISKS;
  }
}
